(() => {
  if (document.querySelector('main[data-template="index"]') === null) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const revealSelectors = [
    '.hamrooq-product-rail__header',
    '.hamrooq-product-card',
    '.hamrooq-category-rail__header',
    '.hamrooq-category-rail__item',
    '.hamrooq-glow-guide__media',
    '.hamrooq-glow-guide__content',
    '.hamrooq-campaign-card',
    '.hamrooq-campaign-banner__content',
    '.collapsible-content__heading',
    '.collapsible-content .accordion',
  ];

  const prepareMotion = (scope = document) => {
    const elements = [...scope.querySelectorAll(revealSelectors.join(','))];
    if (elements.length === 0) return;

    document.documentElement.classList.add('hamrooq-motion');

    elements.forEach((element) => {
      if (element.hasAttribute('data-hamrooq-reveal')) return;

      const siblings = element.parentElement ? [...element.parentElement.children] : [];
      const siblingIndex = Math.max(0, siblings.indexOf(element));
      element.setAttribute('data-hamrooq-reveal', element.matches('[class*="__media"]') ? 'media' : 'content');
      element.style.setProperty('--hamrooq-reveal-delay', `${Math.min(siblingIndex, 5) * 70}ms`);
      observer.observe(element);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
  );

  prepareMotion();
  document.addEventListener('shopify:section:load', (event) => prepareMotion(event.target));
})();
